import { z } from 'zod';

export const CompanyReportSettings = z.object({
  compiledAccrualsAndPayments: z.boolean(),
  loanTransferDocuments: z.boolean(),
  losBalanceAndTransactions: z.boolean(),
  shellpointHelocs: z.boolean().prefault(false),
  kensieMaePayment: z.boolean().prefault(false),
  kensieMaeEscrowDisbursement: z.boolean().prefault(false),
  kensieMaePrincipalPrepayment: z.boolean().prefault(false),
  one80Insurance: z.boolean().prefault(false),
  investorReporting: z.boolean().prefault(false),
  servicingTransferCustomRo: z.boolean().prefault(false),
  alliedInsurance: z.boolean().prefault(false),
  cbreLoanTracking: z.boolean().prefault(false),
  suiLoanTracking: z.boolean().prefault(false),
  achTransactions: z.boolean().prefault(true),
  failedAchTransactions: z.boolean().prefault(true),
  compiledRemittanceReport: z.boolean().prefault(false),
  payoffReimbursementReport: z.boolean().prefault(false),
  reinstatementReport: z.boolean().prefault(false),
  sperlongaCreditReport: z.boolean().prefault(false),
  mctReport: z.boolean().prefault(false),
  lossMitigationReport: z.boolean().prefault(true),
});

export type CompanyReportSettings = z.infer<typeof CompanyReportSettings>;

export const DEFAULT_COMPANY_REPORT_SETTINGS: Required<CompanyReportSettings> = {
  // general reports
  achTransactions: true,
  failedAchTransactions: true,
  compiledRemittanceReport: false,
  payoffReimbursementReport: false,
  reinstatementReport: false,
  investorReporting: false,
  lossMitigationReport: true,

  // lower reports
  compiledAccrualsAndPayments: false,
  loanTransferDocuments: false,
  losBalanceAndTransactions: false,
  shellpointHelocs: false,

  // interlinc reports
  kensieMaePayment: false,
  kensieMaeEscrowDisbursement: false,
  kensieMaePrincipalPrepayment: false,

  // vontive reports
  one80Insurance: false,

  // renovo reports
  servicingTransferCustomRo: false,

  // elite reports
  alliedInsurance: false,
  cbreLoanTracking: false,
  suiLoanTracking: false,

  // ark reports
  mctReport: false,

  // trio reports
  sperlongaCreditReport: false,
};
